<template>
  <div class="flex flex-wrap mb-2" style="position:relative" :style="guideStep >= 7 && guideStep <= 12 && !isAreadlyOpenShowTargetKW ? { zIndex: 100 } : null">
    <loading :active="!this.showKeywordMix"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div>
        <span class="text-red-500">*</span>
        <span class="text-grap-700 align-middle">廣告策略</span>
        <i
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
          v-tooltip.top="''"
        ></i>
        <!-- <button
          v-if="!editPageType"
          id="keywordMix"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['KeywordMix']['video_teaching']}}
        </button> -->
        <div v-if="!editPageType" class="float-right text-blue-500 text-sm cursor-pointer" @click="recover">
          使用預設排序
        </div>
      </div>

      <div class="flex-1 space-y-4">
        <div class="space-y-2">
          <div class="grid grid-cols-12 h-16">
            <div class="col-span-8 text-center bg-gray-100 h-16 py-3 pl-10 pr-3 mr-2">
              <div class="flex justify-between items-center bg-gray-100">
                <div class="font-bold pl-3">測試素材</div>
                <InputSwitch :disabled="editPageType" v-model="customRulesDataList.haveTest" class="flex-none"/>
              </div>
              <div class="text-gray-400 text-left text-xs pl-3">開啟時，各階段會維持相同目標，並以成功素材持續投放</div>
            </div>
            <div v-if="false" class="col-span-3 text-center bg-gray-100 h-16 py-2 pr-2">
              <Dropdown v-model="customRulesDataList.platformTest" optionLabel="name" optionValue="code" :options="platformList" placeholder="請選擇投放平台" class="w-full text-left px-2" style="line-height:30px;" :disabled="editPageType || !customRulesDataList.haveTest"/>
            </div>
          </div>
          <div class="grid grid-cols-12 h-12" v-for="(item, index) in customRulesDataList.stageList" :key="index">
            <div class="col-span-2 bg-gray-100 font-bold text-xl text-center leading-10 h-12" style="border-bottom-width:1px; border-bottom-style:solid; border-bottom-color:rgb(209 213 219); border-left-width:1px; border-left-style:solid; border-left-color:rgb(209 213 219); border-top-width:1px; border-top-style:solid; border-top-color:rgb(209 213 219); line-height:46px;">
              階段{{index + 1}}
            </div>
            <div class="col-span-3">
              <Dropdown v-if="item" v-model="item.marketingValue" optionLabel="name" optionValue="code" :options="item.marketingMethodList" placeholder="請選擇行銷方式" class="w-full h-12" style="line-height:30px;" :disabled="editPageType" @change="useMarketing(index, item.marketingValue)"/>
            </div>
            <div class="col-span-3 text-center pr-2">
              <Dropdown v-model="item.source_platform" optionLabel="name" optionValue="code" :options="platformList" placeholder="請選擇投放平台" class="w-full text-left px-2 h-12" style="line-height:30px;" :disabled="editPageType" @change="usePlatform(index, item.source_platform)"/>
            </div>
            <div v-if="index > 0" class="-ml-2" style="border-bottom-width:1px; border-bottom-style:solid; border-bottom-color:rgb(209 213 219); border-right-width:1px; border-right-style:solid; border-right-color:rgb(209 213 219); border-top-width:1px; border-top-style:solid; border-top-color:rgb(209 213 219);">
              <div v-if="!editPageType" class="p-2 h-10 cursor-pointer" style="line-height:30px;" @click="clearStageItems(index)">
                <img class="w-6 h-6 cursor-pointer" style="margin: 0 auto;" src="../../assets/clear.svg" />
              </div>
            </div>
            <div class="col-span-3">
            </div>
          </div>
          <div v-if="!editPageType">
            <button v-if="customRulesDataList.stageList.length < 10" class="bg-blue-800 text-white px-3 py-2 rounded-md" @click="newStage()">
              <span class="pi pi-plus pr-2"></span>新增階段
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import CascadeSelect from "primevue/cascadeselect";
  import Listbox from 'primevue/listbox';
  import Dropdown from "primevue/dropdown";
  import InputSwitch from 'primevue/inputswitch';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import draggable from "vuedraggable";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'KeywordMix',
    components: {
      CascadeSelect,
      Listbox,
      Dropdown,
      InputSwitch,
      Loading,
      draggable
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: -1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      targetKW: {
        type: Boolean
      },
      targetAD: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      defaultStage: {
        type: Object
      },
      stageMenu: {
        type: Object
      },
      tiktokDefaultStage: {
        type: Object
      },
      tiktokStageMenu: {
        type: Object
      },
      menu: {
        type: Object
      },
      customRulesDataList: {
        type: Object
      },
      itemsDatalist: {
        type: Object
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      },
      pixelId: {
        type: String
      },
      productUrl: {
        type: String
      }
    },
    data() {
      return {
        tags: [
          {
            id: 1,
            text: '選擇關鍵字1',
            checked: false
          },
          {
            id: 2,
            text: '選擇關鍵字2',
            checked: false
          },
          {
            id: 3,
            text: '選擇關鍵字3',
            checked: false
          },
          {
            id: 4,
            text: '選擇關鍵字4',
            checked: false
          },
          {
            id: 5,
            text: '選擇關鍵字5',
            checked: true
          },
          {
            id: 6,
            text: '選擇關鍵字6',
            checked: false
          },
          {
            id: 7,
            text: '選擇關鍵字7',
            checked: false
          },
          {
            id: 8,
            text: '選擇關鍵字8',
            checked: false
          },
          {
            id: 9,
            text: '選擇關鍵字9',
            checked: false
          },
          {
            id: 10,
            text: '選擇關鍵字10',
            checked: false
          },
        ],
        moreTags: [
          {
            id: 1,
            text: '選擇更多關鍵字1',
            checked: false
          },
          {
            id: 2,
            text: '選擇更多關鍵字2',
            checked: false
          },
          {
            id: 3,
            text: '選擇更多關鍵字3',
            checked: false
          }
        ],
        defaultKeySelect: null,
        defaultKeyList: [
          {
              name: 'Australia',
              code: 'AU',
              states: [
                  {
                      name: 'New South Wales',
                      cities: [
                          {cname: 'Sydney', code: 'A-SY'},
                          // {cname: 'Newcastle', code: 'A-NE'},
                          {
                            name: 'Newcastle',
                            district: [
                              { cname: 'Newcastle Area 1', code: 'A-NE-1' },
                              { cname: 'Newcastle Area 2', code: 'A-NE-2' },
                              { cname: 'Newcastle Area 3', code: 'A-NE-3' }
                            ]
                          },
                          {cname: 'Wollongong', code: 'A-WO'}
                      ]
                  },
                  {
                      name: 'Queensland',
                      cities: [
                          {cname: 'Brisbane', code: 'A-BR'},
                          {cname: 'Townsville', code: 'A-TO'}
                      ]
                  },
                  {
                      cname: 'Test Area',
                      code: 'TA'
                  },
              ]
          },
          {
              name: 'Canada',
              code: 'CA',
              states: [
                  {
                      name: 'Quebec',
                      cities: [
                          {cname: 'Montreal', code: 'C-MO'},
                          {cname: 'Quebec City', code: 'C-QU'}
                      ]
                  },
                  {
                      name: 'Ontario',
                      cities: [
                          {cname: 'Ottawa', code: 'C-OT'},
                          {cname: 'Toronto', code: 'C-TO'}
                      ]
                  },

              ]
          },
          {
              name: 'United States',
              code: 'US',
              states: [
                  {
                      name: 'California',
                      cities: [
                          {cname: 'Los Angeles', code: 'US-LA'},
                          {cname: 'San Diego', code: 'US-SD'},
                          {cname: 'San Francisco', code: 'US-SF'}
                      ]
                  },
                  {
                      name: 'Florida',
                      cities: [
                          {cname: 'Jacksonville', code: 'US-JA'},
                          {cname: 'Miami', code: 'US-MI'},
                          {cname: 'Tampa', code: 'US-TA'},
                          {cname: 'Orlando', code: 'US-OR'}
                      ]
                  },
                  {
                      name: 'Texas',
                      cities: [
                          {cname: 'Austin', code: 'US-AU'},
                          {cname: 'Dallas', code: 'US-DA'},
                          {cname: 'Houston', code: 'US-HO'}
                      ]
                  }
              ]
          },
          {
              cname: 'Taiwan',
              code: 'TW'
          }
        ],
        myArray1: [
          { name: "精準興趣", id: 'KW' },
        ],
        myArray2: [
          { name: "年齡性別", id: 'DM' },
        ],
        myArray3: [
          { name: "類似受眾", id: 'LA' },
        ],
        list1: [
          { name: "精準興趣", id: 'KW' },
          { name: "年齡性別", id: 'DM' },
          { name: "類似受眾", id: 'LA' },
        ],
        list2: [
          { name: "再行銷", id: 'RT' },
        ],
        search_keyword: '',
        keywords_suggest: [],
        urlKeywords: [],
        keywordsCheckedList: [],
        country: null,
        countries: null,
        selectCountries: [],
        mark_data: [],
        showKeywordMix: true,
        afterInterests: false,
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=VMMjP-UF6BY",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        testStatus: false,
        marketingMethodList: [
          {name: "精準興趣（Facebook）", code: 'META_KW'},
          {name: "類似受眾（Facebook）", code: 'META_LA'},
          {name: "再行銷（Facebook）", code: 'META_RT'},
          {name: "ASC（Facebook）", code: 'META_ASC'},
        ],
        testselected: 'facebook',
        platformList: [
          {name: "Facebook", code: 'facebook'},
          // {name: "Tiktok", code: 'tiktok'},
        ],
      }
    },
    watch: {
      'youtubeClose':function(v){
        console.log('marketingmethod youtubeClose');
        console.log(v);

        let _tmpYoutubeType = v.split('_');

        console.log('_tmpYoutubeType');
        console.log(_tmpYoutubeType);

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'keyword'){
            this.view_youtube = false
          }
        }

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);
      },
      country(v) {
        console.log('country');
        console.log(this.mark_data);
        console.log(v);
        var inArray = 0
        // console.log(this.keywords_suggest);

        for (let i = 0; i < this.keywords_suggest.length; i++) {
          if (this.keywords_suggest[i].code === v) {
            inArray = 1
          }
        }

        if(inArray == 0 && v != null){
          this.keywords_suggest.push(this.mark_data[v])
        }

        this.search_keyword = ''

        this.$emit('childKeywordUrl', v);
      },
      'customRulesDataList.haveTest': function(v){
        console.log('customRulesDataList.haveTest');
        console.log(v);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        this.$emit('childHaveTest', v+'_'+todayForm);
      },
      'viewDatalistData.product_url': function(v){
        // console.log('viewDatalistData.product_url:' + v);
        this.$emit('childKeywordUrl', v);
      },
      'viewDatalist.keyword_list': function(v){
        console.log('viewDatalistData.keyword_list:' + v);

        if(v != '' && v.length != null && typeof v != 'undefined'){
          if(v.length > 0){
            this.urlKeywords = v;

            this.afterInterests = true;
          }
        }
      },
      'targetAD': function(v){
        console.log('keywordMix targetAD');
        console.log(v);

        if(v == true){
          let itemLength = 0;

          console.log(this.viewDatalistData.keywords);

          for (let k = 0; k < this.viewDatalistData.keywords.length; k++) {
            if (this.viewDatalistData.keywords[k].checked == true) {
              itemLength = parseInt(itemLength) + parseInt(1);
            }
          }

          if(itemLength > 4){
            let _tmp_keywords = this.viewDatalistData.keywords;
            // this.viewDatalistData.keywords = _tmp_keywords.pop();
            _tmp_keywords.splice(_tmp_keywords.length - 1);
          }

          console.log(this.viewDatalistData.keywords);
        }
      },
    },
    methods: {
      onReady() {
        console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('keywordMix');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_keyword')

        this.src = "https://www.youtube.com/watch?v=VMMjP-UF6BY"
        this.vars.start = 134
        this.vars.end = 239
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        console.log(val)
      },
      doDragging(){
        console.log('doDragging');
      },
      defaultGetValue(e){
        console.log(e);

        this.showKeywordMix = false;

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_default_keywords.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            industry: e.value.code
          }))
          .then((response) => {
            console.log(response);
            if(response.data.status == 'success'){
              // this.urlKeywords = response.data.return_data
              // this.urlKeywords = this.urlKeywords.concat(response.data.return_data);

              if(this.urlKeywords.length > 0){
                if(response.data.return_data.length > 0){
                  for(let i = 0; i < response.data.return_data.length; i++){
                    let itemKeyStatus = false;
                    for(let j = 0; j < this.urlKeywords.length; j++){
                      if(response.data.return_data[i].code == this.urlKeywords[j].code){
                        itemKeyStatus = true;
                      }
                    }

                    if(itemKeyStatus == false){
                      console.log('#1');
                      this.urlKeywords.push(response.data.return_data[i]);
                    }
                  }
                }
              } else {
                console.log('#2');
                this.urlKeywords = this.urlKeywords.concat(response.data.return_data);
              }

              console.log(this.urlKeywords);

              // console.log(this.urlKeywords);
              this.$emit('childUrlKeywordsList', this.urlKeywords)
            }

            this.showKeywordMix = true;
            this.afterInterests = true;
            this.defaultKeySelect = null;
          });

        // var inArray = 0
        // console.log(this.urlKeywords);

        // for (let i = 0; i < this.urlKeywords.length; i++) {
        //   if (this.urlKeywords[i].code === e.value.code) {
        //     inArray = 1
        //   }
        // }

        // if(inArray == 0 && e.value.code != null){
        //   let selectKey = {name: e.value.cname, code: e.value.code, type: 'test', is_used: false, checked: false};
        //   this.urlKeywords.push(selectKey);
        // }

        // this.showKeywordMix = true;
        // this.afterInterests = true;
        // this.defaultKeySelect = null;
      },
      keywords_click(checked, index, code){
        let inItem = false
        let itemLength = 0
        let keyLimit = 5;

        if(this.targetAD == true){
          keyLimit = 4;
        }

        for (let k = 0; k < this.viewDatalistData.keywords.length; k++) {
          if (this.viewDatalistData.keywords[k].checked == true) {
            itemLength = parseInt(itemLength) + parseInt(1);
          }
        }

        if(checked == false){
          if(itemLength < keyLimit){
            for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
              if (this.viewDatalistData.keywords[i].code === code) {
                this.viewDatalistData.keywords[i].checked = true
                this.urlKeywords[index].checked = true
                inItem = true
              }
            }

            if(inItem == false){
              this.viewDatalistData.keywords.push({
                name: this.urlKeywords[index].name,
                code: code,
                type: this.urlKeywords[index].type,
                checked: true
              });
              this.urlKeywords[index].checked = true
            }
          } else {
            let swal_text = this.lang['components']['Event']['KeywordMix']['methods']['keywords_click']['swal_text'];

            if(this.targetAD == true){
              swal_text = this.lang['components']['Event']['KeywordMix']['methods']['keywords_click']['ad_swal_text'];
            }

            Swal.fire(
                      this.lang['components']['Event']['KeywordMix']['methods']['keywords_click']['swal_title'],
                      swal_text,
                      "error"
                    )
          }
        } else {
          for(let j = 0; j < this.urlKeywords.length; j++){
            if(this.urlKeywords[j].code === code){
              this.urlKeywords[j].checked = false
              for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
                if (this.viewDatalistData.keywords[i].code === code) {
                  this.viewDatalistData.keywords[i].checked = false
                }
              }
            }
          }
        }
      },
      keywords_suggest_click(checked, index, code){
        let inItem = false
        let itemLength = 0
        let keyLimit = 5;

        if(this.targetAD == true){
          keyLimit = 4;
        }

        for (let k = 0; k < this.viewDatalistData.keywords.length; k++) {
          if (this.viewDatalistData.keywords[k].checked == true) {
            itemLength = parseInt(itemLength) + parseInt(1);
          }
        }

        if(checked == false){
          if(itemLength < keyLimit){
            for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
              if (this.viewDatalistData.keywords[i].code === code) {
                this.viewDatalistData.keywords[i].checked = true
                this.keywords_suggest[index].checked = true
                inItem = true
              }
            }

            if(inItem == false){
              this.viewDatalistData.keywords.push({
                name: this.keywords_suggest[index].name,
                code: code,
                type: this.keywords_suggest[index].type,
                checked: true
              });
              this.keywords_suggest[index].checked = true
            }
          } else {
            let swal_text = this.lang['components']['Event']['KeywordMix']['methods']['keywords_suggest_click']['swal_text'];

            if(this.targetAD == true){
              swal_text = this.lang['components']['Event']['KeywordMix']['methods']['keywords_suggest_click']['ad_swal_text'];
            }

            Swal.fire(
                      this.lang['components']['Event']['KeywordMix']['methods']['keywords_suggest_click']['swal_title'],
                      swal_text,
                      "error"
                    )
          }
        } else {
          for(let j = 0; j < this.keywords_suggest.length; j++){
            if(this.keywords_suggest[j].code === code){
              this.keywords_suggest[j].checked = false
              for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
                if (this.viewDatalistData.keywords[i].code === code) {
                  this.viewDatalistData.keywords[i].checked = false
                }
              }
            }
          }
        }
      },
      un_select(code){
        if(this.editPageType == false){
          for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
            if (this.viewDatalistData.keywords[i].code === code) {
              this.viewDatalistData.keywords[i].checked = false

              for(let j = 0; j < this.urlKeywords.length; j++){
                if(this.urlKeywords[j].code === code){
                  this.urlKeywords[j].checked = false
                }
              }

              for(let j = 0; j < this.keywords_suggest.length; j++){
                if(this.keywords_suggest[j].code === code){
                  this.keywords_suggest[j].checked = false
                }
              }
            }
          }
        }
      },
      url_interests () {
        let Expression = /http(s)?:\/\/[\w-\.]+(:\d+)?(\/[\w\/\.]*)?(\?\S*)?(#\S*)?/g;
        let objExp = new RegExp(Expression);
        let input_url = this.viewDatalistData.product_url;
        if(objExp.test(input_url) != true){
          Swal.fire({
            icon: 'error',
            title: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['swal_title'],
            text: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['swal_text'],
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['confirm_button']
          }).then((result) => {
            this.viewDatalistData.product_url = '';
          })
        } else {
          this.showKeywordMix = false;
            axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_url_interests.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                url: input_url,
                special_ad_category: this.viewDatalistData.special_ad_category,
                keywords: this.viewDatalistData.keywords
              }))
              .then((response) => {
                console.log(this.urlKeywords);
                console.log(response);
                if(response.data.status == 'success'){
                  // this.urlKeywords = response.data.return_data
                  // this.urlKeywords = this.urlKeywords.concat(response.data.return_data);

                  if(this.urlKeywords.length > 0){
                    if(response.data.return_data.length > 0){
                      for(let i = 0; i < response.data.return_data.length; i++){
                        let itemKeyStatus = false;
                        for(let j = 0; j < this.urlKeywords.length; j++){
                          if(response.data.return_data[i].code == this.urlKeywords[j].code){
                            itemKeyStatus = true;
                          }
                        }

                        if(itemKeyStatus == false){
                          console.log('#1');
                          this.urlKeywords.push(response.data.return_data[i]);
                        }
                      }
                    }
                  } else {
                    console.log('#2');
                    this.urlKeywords = this.urlKeywords.concat(response.data.return_data);
                  }

                  console.log(this.urlKeywords);

                  // console.log(this.urlKeywords);
                  this.$emit('childUrlKeywordsList', this.urlKeywords)
                }

                this.showKeywordMix = true;
                this.afterInterests = true;
              });
        }
      },
      suggest (){
        if(this.editPageType == false){
          this.showKeywordMix = false;

          // console.log('this.viewDatalistData.keywords');
          // console.log(this.viewDatalistData.keywords);

          let _tmp_keyword_ids = this.viewDatalistData.keywords

          if(_tmp_keyword_ids.length <= 0 || typeof _tmp_keyword_ids == 'undefined'){
            _tmp_keyword_ids = this.urlKeywords
          }

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_keywords_suggest.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              special_ad_category: this.viewDatalistData.special_ad_category,
              keyword_ids: _tmp_keyword_ids,
              form_list: this.keywords_suggest
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                this.keywords_suggest = response.data.return_data
                this.$emit('update:itemsDatalist', response.data.return_data)

                this.$emit('childKeywordsSuggestList', this.keywords_suggest)
              }

              this.showKeywordMix = true;
            });
        }
      },
      keyup_get_data(){
        // console.log('search_keyword');
        // console.log(this.search_keyword);

        this.country = null
        this.countries = null

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_keyword_search.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            special_ad_category: this.viewDatalistData.special_ad_category,
            q: this.search_keyword
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              this.countries = response.data.return_data
              this.mark_data = response.data.mark_data
            }
          });
      },
      add: function() {
        this.list.push({ name: "Juan" });
      },
      replace: function() {
        this.list = [{ name: "Edgard" }];
      },
      clone: function(el) {
        return {
          name: el.name + " cloned"
        };
      },
      log: function(evt) {
        console.log('b');
        console.log('this.list1');
        console.log(this.list1);
        console.log('this.list2');
        console.log(this.list2);
        window.console.log(evt);

        if(this.list1.length == 4){
          let poppedElement = this.list1.pop();
          this.list2.push(poppedElement);
        }

        console.log('a');
        console.log('this.list1');
        console.log(this.list1);
        console.log('this.list2');
        console.log(this.list2);
      },
      checkMove: function(evt){
        console.log('checkMove');
        console.log(evt);
        return (evt.draggedContext.element.name!=='apple');
      },
      recover(){
        this.customRulesDataListData.editIndex = 0;
        this.customRulesDataListData.haveTest = true;
        this.customRulesDataList.haveTest = true;
        this.customRulesDataListData.stageList = [
          { marketingValue: 'META_KW', source_platform: 'facebook', marketingMethodList: [
            {name: "精準興趣（Facebook）", code: 'META_KW'},
            {name: "類似受眾（Facebook）", code: 'META_LA'},
            {name: "再行銷（Facebook）", code: 'META_RT'},
            {name: "ASC（Facebook）", code: 'META_ASC'},
          ]},
          { marketingValue: 'META_LA', source_platform: 'facebook', marketingMethodList: [
            {name: "精準興趣（Facebook）", code: 'META_KW'},
            {name: "類似受眾（Facebook）", code: 'META_LA'},
            {name: "再行銷（Facebook）", code: 'META_RT'},
            {name: "ASC（Facebook）", code: 'META_ASC'},
          ]},
          { marketingValue: 'META_RT', source_platform: 'facebook', marketingMethodList: [
            {name: "精準興趣（Facebook）", code: 'META_KW'},
            {name: "類似受眾（Facebook）", code: 'META_LA'},
            {name: "再行銷（Facebook）", code: 'META_RT'},
            {name: "ASC（Facebook）", code: 'META_ASC'},
          ]}
        ];

        let _tmpSubCampaignsContent = [];

        // if(this.customRulesDataListData.subCampaignsContent[1] != null && this.customRulesDataListData.subCampaignsContent[1] != '' && typeof this.customRulesDataListData.subCampaignsContent[1] != 'undefined' ){
        //   this.customRulesDataListData.subCampaignsContent[1]
        // } else {

        // }

        console.log('b _tmpSubCampaignsContent');
        console.log(_tmpSubCampaignsContent);

        _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_TEST']);
        _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_KW']);
        _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_LA']);
        _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_RT']);

        console.log('a _tmpSubCampaignsContent');
        console.log(_tmpSubCampaignsContent);

        this.customRulesDataListData.subCampaignsContent = _tmpSubCampaignsContent;

        console.log('recover this.customRulesDataListData');
        console.log(this.customRulesDataListData);

        let _tmpMenu = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_TEST']));

        this.menuData[1] = _tmpMenu;

        this.useMarketing(0, 'META_KW');
        this.useMarketing(1, 'META_LA');
        this.useMarketing(2, 'META_RT');

      },
      newStage(){
        if(this.editPageType == false){
          let _tmpStageList = this.customRulesDataListData.stageList;
          let _tmpSubCampaignsContent = this.customRulesDataListData.subCampaignsContent;

          console.log('b _tmpStageList');
          console.log(_tmpStageList);
          console.log('b _tmpSubCampaignsContent');
          console.log(_tmpSubCampaignsContent);

          _tmpStageList.push({ marketingValue: 'META_KW'});

          let _tmpStageContent = JSON.parse(JSON.stringify(this.defaultStage['USE_TEST']['META_KW']));
          let _tmpMenu = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_KW']));

          if(this.customRulesDataListData.haveTest == false){
            _tmpStageContent = JSON.parse(JSON.stringify(this.defaultStage['NOT_USE_TEST']['META_KW']));
            _tmpMenu = JSON.parse(JSON.stringify(this.stageMenu['NOT_USE_TEST']['META_KW']));
          }

          _tmpSubCampaignsContent.push(_tmpStageContent);

          console.log('a _tmpStageList');
          console.log(_tmpStageList);
          console.log('a _tmpSubCampaignsContent');
          console.log(_tmpSubCampaignsContent);

          console.log('b _tmpMenu');
          console.log(_tmpMenu);

          let _labelIndex = _tmpSubCampaignsContent.length - parseInt(1);
          if(this.customRulesDataListData.haveTest == false){
            _labelIndex = _tmpSubCampaignsContent.length;
          }

          _tmpMenu.title = '第'+_labelIndex+'階段：'+_tmpMenu.title;

          console.log('a _tmpMenu');
          console.log(_tmpMenu);

          this.menuData.push(_tmpMenu);
        }
      },
      clearStageItems(index){
        console.log('b this.customRulesDataListData.stageList');
        console.log(this.customRulesDataListData.stageList);

        Swal.fire({
          title: '廣告策略-刪除階段',
          html: '刪除該階段後，該階段所設定的值也會一併刪除不保留，請問您確定要刪除嗎？',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: '確定刪除',
          cancelButtonText: '取消',
        }).then((result) => {
          if (result.isConfirmed) {
            console.log(result);

            this.customRulesDataListData.stageList.splice(index, 1);

            if(this.customRulesDataListData.haveTest == false){
              let _menuIndex = index + parseInt(1);
              this.customRulesDataListData.subCampaignsContent.splice(index, 1);
              this.menuData.splice(_menuIndex, 1);
            } else {
              let _testIndex = index + parseInt(1);
              let _menuIndex = index + parseInt(2);
              this.customRulesDataListData.subCampaignsContent.splice(_testIndex, 1);
              this.menuData.splice(_menuIndex, 1);
            }

            console.log('this.menuData');
            console.log(this.menuData);

            let stageIndex = 1;
            let _tmpMenu = this.menuData;
            console.log('b _tmpMenu');
            console.log(_tmpMenu);
            for(let i = 0; i < _tmpMenu.length; i++){
              console.log('_tmpMenu[1].title');
              console.log(_tmpMenu[1].title);
              let _tmpTitle = _tmpMenu[i].title.split('：');
              if(_tmpMenu[1].title == '測試素材（Facebook）' && i > 1){
                console.log('#1');
                _tmpMenu[i].title = '第'+stageIndex+'階段：'+_tmpTitle[1];
                stageIndex++;
              } else if(_tmpMenu[1].title != '測試素材（Facebook）' && i > 0){
                console.log('#2');
                _tmpMenu[i].title = '第'+stageIndex+'階段：'+_tmpTitle[1];
                stageIndex++;
              }
              console.log('stageIndex');
              console.log(stageIndex);
            }

            console.log('a _tmpMenu');
            console.log(_tmpMenu);
            console.log('b this.menuData');
            console.log(this.menuData);

            // this.menuData = _tmpMenu;

            console.log('a this.menuData');
            console.log(this.menuData);
          }
        });

        console.log('a this.customRulesDataListData.stageList');
        console.log(this.customRulesDataListData.stageList);
      },
      useMarketing(index, value){
        console.log('useMarketing');
        console.log(index+'：'+value);

        console.log('defaultStage');
        console.log(this.defaultStage);
        console.log(this.tiktokDefaultStage);

        console.log('b this.menuData');
        console.log(this.menuData);

        console.log('stageMenu');
        console.log(this.stageMenu);
        console.log(this.tiktokStageMenu);

        let _testIndex = index + parseInt(1);
        let _labelIndex = index + parseInt(1);
        let _dataIndex = index + parseInt(2);

        let _tmpStageContent = {};
        let _tmpMenu = {};
        if(value == 'TIKTOK_KW' || value == 'TIKTOK_RT'){
          _tmpStageContent = JSON.parse(JSON.stringify(this.tiktokDefaultStage['USE_TEST'][value]));
          _tmpMenu = JSON.parse(JSON.stringify(this.tiktokStageMenu['USE_TEST'][value]));
        } else {
          _tmpStageContent = JSON.parse(JSON.stringify(this.defaultStage['USE_TEST'][value]));
          _tmpMenu = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST'][value]));
        }

        console.log('b _tmpMenu');
        console.log(_tmpMenu);

        console.log('#1 _tmpStageContent');
        console.log(_tmpStageContent);

        console.log('#1 _tmpStageContent.pdData.publisher_platforms_list');
        console.log(_tmpStageContent.pdData.publisher_platforms_list);

        if(this.customRulesDataListData.haveTest == false){
          _testIndex = index;
          _dataIndex = index + parseInt(1);
          if(value == 'TIKTOK_KW' || value == 'TIKTOK_RT'){
            _tmpStageContent = JSON.parse(JSON.stringify(this.tiktokDefaultStage['NOT_USE_TEST'][value]));
            _tmpMenu = JSON.parse(JSON.stringify(this.tiktokStageMenu['NOT_USE_TEST'][value]));
          } else {
            _tmpStageContent = JSON.parse(JSON.stringify(this.defaultStage['NOT_USE_TEST'][value]));
            _tmpMenu = JSON.parse(JSON.stringify(this.stageMenu['NOT_USE_TEST'][value]));
          }
        }

        console.log('#2 _tmpStageContent');
        console.log(_tmpStageContent);

        console.log('#2 _tmpStageContent.pdData.publisher_platforms_list');
        console.log(_tmpStageContent.pdData.publisher_platforms_list);

        _tmpMenu.title = '第'+_labelIndex+'階段：'+_tmpMenu.title;

        console.log('a _tmpMenu');
        console.log(_tmpMenu);

        this.customRulesDataListData.subCampaignsContent[_testIndex] = _tmpStageContent;

        console.log('this.customRulesDataListData');
        console.log(this.customRulesDataListData);

        console.log('_labelIndex');
        console.log(_labelIndex);
        console.log('_dataIndex');
        console.log(_dataIndex);

        this.menuData[_dataIndex] = _tmpMenu;

        console.log('a this.menuData');
        console.log(this.menuData);

        if(value == 'META_ASC'){
          console.log('有用asc');
          this.$emit('childUseASC', true);
        } else {
          this.$emit('childUseASC', false);
        }

        // this.$emit('childChangeStageMarketing', index+'|'+value);
      },
      usePlatform(index, value){
        console.log('usePlatform');
        console.log(index+'：'+value);

        if(value == 'tiktok'){
          this.customRulesDataList.stageList[index].marketingMethodList = [
            {name: "精準興趣（Tiktok）", code: 'TIKTOK_KW'},
            // {name: "再行銷", code: 'TIKTOK_RT'},
          ];

          this.customRulesDataList.stageList[index].marketingValue = 'TIKTOK_KW';
          this.useMarketing(index, 'TIKTOK_KW');
        } else {
          this.customRulesDataList.stageList[index].marketingMethodList = [
            {name: "精準興趣（Facebook）", code: 'META_KW'},
            {name: "類似受眾（Facebook）", code: 'META_LA'},
            {name: "再行銷（Facebook）", code: 'META_RT'},
            {name: "ASC（Facebook）", code: 'META_ASC'},
          ];

          this.customRulesDataList.stageList[index].marketingValue = 'META_KW';
          this.useMarketing(index, 'META_KW');
        }

        console.log('marketingMethodList');
        console.log(this.customRulesDataList.stageList[index].marketingMethodList);
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      menuData: {
        get: function () {
          return this.menu
        },
        set: function (value) {
          this.$emit('update:menuData', value)
        },
      },
      customRulesDataListData: {
        get: function () {
          return this.customRulesDataList
        },
        set: function (value) {
          this.$emit('update:customRulesDataListData', value)
        },
      }
    }
  }
</script>
<style type="text/css">
.awareness {
  position: absolute;
  width: 30%;/* 箭頭區塊的寬度 */
  right: -40px;
  top: 50%;
  z-index: 0;
}
.awareness::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -8px;
  width: 8px; /* 箭頭的寬度 */
  height: 8px; /* 箭頭的高度 */
  border-top: 1px solid #F3705C; /* 箭頭的上邊 */
  border-right: 1px solid #F3705C; /* 箭頭的右邊 */
  transform: translate(-50%, -50%) rotate(45deg); /* 旋轉45度，使其成為箭頭 */
}

.awareness::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 10px; /* 箭頭寬度的位置 */
  width: calc(100% - 10px); /* 虛線的寬度 */
  height: 2px; /* 虛線的高度 */
  border-bottom: 1px dashed #F3705C; /* 虛線 */
  transform: translateY(-50%); /* 垂直置中 */
}

.consideration {
  position: absolute;
  width: 30%;/* 箭頭區塊的寬度 */
  right: -40px;
  top: 50%;
  z-index: 0;
}
.consideration::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -8px;
  width: 8px; /* 箭頭的寬度 */
  height: 8px; /* 箭頭的高度 */
  border-top: 1px solid #F08C50; /* 箭頭的上邊 */
  border-right: 1px solid #F08C50; /* 箭頭的右邊 */
  transform: translate(-50%, -50%) rotate(45deg); /* 旋轉45度，使其成為箭頭 */
}

.consideration::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 10px; /* 箭頭寬度的位置 */
  width: calc(100% - 10px); /* 虛線的寬度 */
  height: 2px; /* 虛線的高度 */
  border-bottom: 1px dashed #F08C50; /* 虛線 */
  transform: translateY(-50%); /* 垂直置中 */
}

.conversion {
  position: absolute;
  width: 30%;/* 箭頭區塊的寬度 */
  right: -40px;
  top: 50%;
  z-index: 0;
}
.conversion::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -8px;
  width: 8px; /* 箭頭的寬度 */
  height: 8px; /* 箭頭的高度 */
  border-top: 1px solid #95C325; /* 箭頭的上邊 */
  border-right: 1px solid #95C325; /* 箭頭的右邊 */
  transform: translate(-50%, -50%) rotate(45deg); /* 旋轉45度，使其成為箭頭 */
}

.conversion::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 10px; /* 箭頭寬度的位置 */
  width: calc(100% - 10px); /* 虛線的寬度 */
  height: 2px; /* 虛線的高度 */
  border-bottom: 1px dashed #95C325; /* 虛線 */
  transform: translateY(-50%); /* 垂直置中 */
}
</style>